// modalSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactElement } from 'react';

export type TModal = ReactElement | false

const initialState: any = false;

// Create a slice
const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        setModal: (state: TModal, action: PayloadAction<TModal>) => {
            
            return action.payload;
        },
        closeModal: (state: TModal) => {
            return false
        }
    },
});

// Export the actions and reducer
export const { setModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;

